import { humanise } from './format';
import type { LensDocument, LensDocumentData, Param } from './types';

const GRAIN_WORDS: Record<string, string> = { day: 'daily', week: 'weekly', month: 'monthly', quarter: 'quarterly', year: 'yearly' };

export function boardLabels(document: LensDocument, data?: LensDocumentData): Map<string, string> {
  const known = new Map<string, string>();
  for (const envelope of Object.values(data?.queries ?? {})) for (const column of envelope.columns) known.set(column.name, column.label);
  for (const [id, measure] of Object.entries(document.measures)) if (measure.label) known.set(id, measure.label);
  return known;
}

export function paramOptionLabel(param: Param | undefined, labels: Map<string, string>, option: string): string {
  const role = param && 'sql' in param ? param.role : undefined;
  if (role === 'grain') return GRAIN_WORDS[option.toLowerCase()] ?? option;
  if (role === 'dimension') return /^(all|none)$/i.test(option) ? 'overall' : `by ${option.toLowerCase()}`;
  if (role === 'measure') return option;
  if (option === 'none') return 'overall';
  if (param && 'columns' in param) return `by ${(labels.get(option) ?? humanise(option)).toLowerCase()}`;
  return labels.get(option) ?? humanise(option);
}

export function plainTitle(text: string, document: LensDocument, data?: LensDocumentData): string {
  const labels = boardLabels(document, data);
  return text.replace(/\s*·\s*(?=\{\$)/g, ' ').replace(/\{\$([a-z0-9_]+)\}/gi, (_, name: string) => paramOptionLabel(document.params[name], labels, String(data?.params[name] ?? '')));
}
